import { USER_DATA_TYPE } from '../constants';
import {
  getUserData,
  isAuthContextMatching,
  tagContextMatches,
} from '../utils';
import { useUserTags } from './useLocalTags';
import { useInstantSearch, useQueryRules } from 'react-instantsearch-core';
import { ICustomer, IUserData, MerchCard } from '@monofront/types';
import { logger } from '@monofront/logging';

export const useMerchCard = (
  useAuthentication: () => {
    customer?: { omsTags?: ICustomer['omsTags'] } | null;
    isAuthenticated: boolean;
    isMember: boolean;
  },
) => {
  const localTags = useUserTags(useAuthentication);
  const { isAuthenticated, isMember } = useAuthentication();
  const { results } = useInstantSearch();
  const { items } = useQueryRules();
  const merchCards = items.filter((item) =>
    [USER_DATA_TYPE.MERCH_CARD].includes(item.type),
  );

  if (merchCards.length > 1) {
    logger.error(
      'More than one merch card have been defined for the current query',
      { merchCards },
    );
  }

  const merchCard = (getUserData(
    results._rawResults[0]?.userData as unknown as Array<IUserData> | undefined,
    USER_DATA_TYPE.MERCH_CARD,
  ) ?? merchCards[0]?.data) as MerchCard | null;
  const merchCardCondition = merchCard?.condition ?? '';
  const isMerchCardVisible =
    tagContextMatches(merchCardCondition, {
      tags: { user: localTags },
      isAuthenticated,
      isMember,
    }) &&
    isAuthContextMatching(merchCard?.authContext, isAuthenticated!, isMember!);

  return isMerchCardVisible ? merchCard : null;
};
